/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { HchbTeamSummary } from './HchbTeamSummary';
import {
    HchbTeamSummaryFromJSON,
    HchbTeamSummaryFromJSONTyped,
    HchbTeamSummaryToJSON,
} from './HchbTeamSummary';

/**
 * 
 * @export
 * @interface HchbBranchSummary
 */
export interface HchbBranchSummary {
    /**
     * 
     * @type {string}
     * @memberof HchbBranchSummary
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof HchbBranchSummary
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof HchbBranchSummary
     */
    external_id?: string;
    /**
     * 
     * @type {Array<HchbTeamSummary>}
     * @memberof HchbBranchSummary
     */
    teams?: Array<HchbTeamSummary>;
}

/**
 * Check if a given object implements the HchbBranchSummary interface.
 */
export function instanceOfHchbBranchSummary(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function HchbBranchSummaryFromJSON(json: any): HchbBranchSummary {
    return HchbBranchSummaryFromJSONTyped(json, false);
}

export function HchbBranchSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbBranchSummary {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'external_id': !exists(json, 'external_id') ? undefined : json['external_id'],
        'teams': !exists(json, 'teams') ? undefined : ((json['teams'] as Array<any>).map(HchbTeamSummaryFromJSON)),
    };
}

export function HchbBranchSummaryToJSON(value?: HchbBranchSummary | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'external_id': value.external_id,
        'teams': value.teams === undefined ? undefined : ((value.teams as Array<any>).map(HchbTeamSummaryToJSON)),
    };
}

